module.exports = __webpack_public_path__ + "img/leaf-light.d8432caf.svg";